import { render, staticRenderFns } from "./registrationrecord.vue?vue&type=template&id=56aacef7"
import script from "./registrationrecord.vue?vue&type=script&lang=js"
export * from "./registrationrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports